module.exports = __webpack_public_path__ + "static/media/instrument.a59ad44a.svg";